(() => {
  const config = window.ROAMUNO_LAUNCH_ALLOWLIST;
  const script = document.currentScript;
  if (!config || !Array.isArray(config.variantIds) || !config.variantIds.length || !script) return;

  const allowedVariantIds = new Set(config.variantIds.map(String));
  window.ROAMUNO_LAUNCH_ELIGIBILITY = {
    isAllowedVariantId: (variantId) => allowedVariantIds.has(String(variantId || '')),
  };
  const unavailableLabel = script.dataset.unavailableLabel || 'This package is not available during the initial launch';
  const quantityLabel = script.dataset.quantityLabel || 'Maximum 5 eSIMs per order';
  const addFormSelector = 'form[action*="/cart/add"]';
  const buttonSelector = 'button[type="submit"], button[name="add"]';

  const getVariantId = (form) => String(new FormData(form).get('id') || '');
  const getQuantity = (form) => Number(new FormData(form).get('quantity') || 1);

  const setButtonState = (button, blocked, label) => {
    const text = button.querySelector('span') || button;
    if (!button.dataset.ruOriginalLabel) button.dataset.ruOriginalLabel = text.textContent.trim();
    button.disabled = blocked;
    button.setAttribute('aria-disabled', String(blocked));
    button.classList.toggle('ru-launch-disabled', blocked);
    const nextLabel = blocked ? label : button.dataset.ruOriginalLabel;
    if (text.textContent.trim() !== nextLabel) text.textContent = nextLabel;
  };

  const updateForm = (form) => {
    if (!(form instanceof HTMLFormElement)) return;
    const allowed = allowedVariantIds.has(getVariantId(form));
    const quantity = form.querySelector('input[name="quantity"]');
    if (quantity) {
      quantity.max = '5';
      quantity.dataset.max = '5';
    }
    const formId = form.getAttribute('id');
    const associatedButtons = formId
      ? [...document.querySelectorAll(`[form="${formId}"]`)].filter((button) => button.matches(buttonSelector))
      : [];
    [...form.querySelectorAll(buttonSelector), ...associatedButtons]
      .forEach((button) => setButtonState(button, !allowed, unavailableLabel));
    form.dispatchEvent(new CustomEvent('roamuno:launch-eligibility', {
      bubbles: true,
      detail: { allowed, variantId: getVariantId(form) },
    }));
  };

  const updateAll = (root = document) => {
    if (root.matches?.(addFormSelector)) updateForm(root);
    root.querySelectorAll?.(addFormSelector).forEach(updateForm);
  };

  let selectionPending = false;
  const updateProductOptions = () => {
    const productVariants = document.querySelector('[data-product-variants]');
    const productPicker = document.querySelector('main variant-selects');
    const productForm = document.querySelector('main product-info form[action*="/cart/add"]');
    if (!productVariants || !productPicker || !productForm) return;
    try {
      const variants = JSON.parse(productVariants.textContent || '[]');
      if (!variants.length || variants.some((variant) => Array.isArray(variant.options) && variant.options.length > 1)) return;
      productPicker.querySelectorAll('input[type="radio"]').forEach((input) => {
        const optionAllowed = variants.some((variant) => (
          variant.available && allowedVariantIds.has(String(variant.id)) && String(variant.title) === String(input.value)
        ));
        input.disabled = !optionAllowed;
        input.setAttribute('aria-disabled', String(!optionAllowed));
        input.classList.toggle('disabled', !optionAllowed);
        document.querySelector(`label[for="${input.id}"]`)?.classList.toggle('ru-launch-option-disabled', !optionAllowed);
      });
      const firstAllowed = variants
        .find((variant) => variant.available && allowedVariantIds.has(String(variant.id)));
      if (!firstAllowed || allowedVariantIds.has(getVariantId(productForm)) || selectionPending) return;
      const input = [...productPicker.querySelectorAll('input[type="radio"]')]
        .find((option) => option.value === firstAllowed?.title);
      if (!input) return;
      selectionPending = true;
      Promise.all([
        customElements.whenDefined('variant-selects'),
        customElements.whenDefined('product-info'),
      ]).then(() => {
        requestAnimationFrame(() => {
          input.click();
          selectionPending = false;
        });
      });
    } catch (_) {
      // Keep Shopify's selected variant when embedded product data is unavailable.
    }
  };

  const syncPage = () => {
    updateAll();
    updateProductOptions();
  };

  syncPage();
  document.addEventListener('change', () => queueMicrotask(syncPage));
  document.addEventListener('variant:change', () => queueMicrotask(syncPage));
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches(addFormSelector)) return;
    const allowed = allowedVariantIds.has(getVariantId(form));
    const quantityAllowed = getQuantity(form) <= 5;
    if (allowed && quantityAllowed) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = form.querySelector(buttonSelector);
    if (button) setButtonState(button, true, allowed ? quantityLabel : unavailableLabel);
  }, true);

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) queueMicrotask(syncPage);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
